<template>
  <div>
    <kst-output print-mode field="VendorID" :data="data" :catalog="Catalog"/>
    <kst-output print-mode field="VendorAddress" :data="data" :catalog="Catalog"/>
    <kst-output print-mode field="WarehouseID" :data="data" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../RrcvCatalog";

export default {
  props: {
    data: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>